import { Reveal } from "@/components/site/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "What is Dr. Sangeeta Roy's area of specialisation?", a: "Dr. Sangeeta Roy is associated with the Department of Pharmacology at SGRR Medical College and Hospital, Dehradun. Pharmacology is the branch of medicine concerned with the study of medicines and their effects on the body." },
  { q: "How can I request a consultation or enquiry?", a: "You can use the 'Schedule a Consultation' form on this website to submit an enquiry, or contact the clinic directly using the provided contact details. This information is general and not a substitute for professional medical advice." },
  { q: "How can I request an appointment?", a: "You can use the 'Schedule a Consultation' form on this website to submit an enquiry, or contact the clinic directly using the provided contact details." },
  { q: "Where is Dr. Sangeeta Roy associated?", a: "Dr. Sangeeta Roy is associated with SGRR Medical College and Hospital in Dehradun, Uttarakhand." },
  { q: "How can I contact the clinic?", a: "Use the contact details in the Contact and Location sections of this website. Specific phone, WhatsApp and address details are managed by the clinic." },
  { q: "Do I need an appointment before visiting?", a: "Appointment and visit arrangements are confirmed by the clinic. Please submit an enquiry or contact the clinic to confirm the consultation process." },
  { q: "Can I request a consultation online?", a: "You can submit an online enquiry through this website. Online booking is not automatically confirmed unless the clinic has connected an appointment system; the clinic will provide appointment guidance." },
];

export function Faq() {
  return (
    <section id="faq" className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal className="lg:sticky lg:top-28">
              <span className="label">FAQs</span>
              <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight mt-4 text-[#0A192F]">
                Frequently Asked Questions
              </h2>
              <p className="mt-5 text-[#475569] leading-relaxed">
                Informational answers about the doctor and consultation enquiries. Not personalised medical advice.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal>
              <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                {faqs.map((f, i) => (
                  <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E2E8F0]">
                    <AccordionTrigger className="text-left font-display text-xl md:text-2xl text-[#0A192F] hover:no-underline py-6" data-testid={`faq-trigger-${i}`}>
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#475569] text-base leading-relaxed pb-6">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
